import { Link, Typography } from '@mui/material';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ContactUsModal from 'components/Modal/modals/ContactUs';
import { Alert } from 'components';
import { Url } from 'utils/urls';

export enum AccountBlockedInfoOptions {
  WITH_RESET_PASSWORD = 'WITH_RESET_PASSWORD',
  WITHOUT_RESET_PASSWORD = 'WITHOUT_RESET_PASSWORD'
}

const AccountBlocked = ({
  option = AccountBlockedInfoOptions.WITH_RESET_PASSWORD
}: {
  option?: AccountBlockedInfoOptions;
}) => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div style={{ margin: '10px 0' }}>
      <ContactUsModal
        open={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <Alert
        variant="standard"
        severity="error"
        title={t('PAGE_LOGIN_ACCOUNT_BLOCKED_TITLE')}
      >
        <div>
          {option === AccountBlockedInfoOptions.WITH_RESET_PASSWORD ? (
            <>
              <Typography component="span" variant="body2">
                {t('PAGE_LOGIN_ACCOUNT_BLOCKED_MESSAGE_PART_1')}
              </Typography>
              <Link href={Url.unblockAccount} variant="body2">
                {t('PAGE_LOGIN_ACCOUNT_UNLOCK_CLICK_HERE')}
              </Link>
              <Typography component="span" variant="body2">
                {t('PAGE_LOGIN_ACCOUNT_BLOCKED_MESSAGE_PART_2')}
              </Typography>
              <Link
                sx={{ cursor: 'pointer', display: 'contents' }}
                component="button"
                variant="body2"
                type="button"
                onClick={() => {
                  setIsContactModalOpen(true);
                }}
              >
                {t('PAGE_LOGIN_ACCOUNT_BLOCKED_CONTACT')}
              </Link>
              .
            </>
          ) : (
            <Trans i18nKey="PAGE_LOGIN_ACCOUNT_BLOCKED_MESSAGE_WITHOUT_RESET">
              <Typography />
              <Link
                sx={{ cursor: 'pointer', display: 'contents' }}
                component="button"
                variant="body2"
                type="button"
                onClick={() => {
                  setIsContactModalOpen(true);
                }}
              />
              <Typography />
            </Trans>
          )}
        </div>
      </Alert>
    </div>
  );
};

export default AccountBlocked;
